import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.mitteilungs-vorlage-veranstaltungs-typen-hinzufuegen';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungsVorlageVeranstaltungsTypenHinzufuegenEffects {

    MitteilungsVorlageVeranstaltungsTypenHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_MITTEILUNGS_VORLAGE_VERANSTALTUNGS_TYPEN_HINZUFUEGEN),
        mergeMap((x: ac.PostMitteilungsVorlageVeranstaltungsTypenHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postMitteilungsVorlageVeranstaltungsTypenHinzufuegen(x.mitteilungsVorlageTypMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostMitteilungsVorlageVeranstaltungsTypenHinzufuegenErfolgreichAction(result, x.mitteilungsVorlageTypMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostMitteilungsVorlageVeranstaltungsTypenHinzufuegenFehlerAction(error, x.mitteilungsVorlageTypMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungsVorlageCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungsVorlageCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungsVorlageCommandService);
        }
        return this.service;
    }
}
